import {
  buildFetchInterviewers,
  fetchInterviewersUsecase as _fetchInterviewersUsecase,
} from "./get-interviewers";

import InterviewerRepository from "../../ports/interviewerRepository";

// eslint-disable-next-line import/no-anonymous-default-export
export default (dependencies: {
  interviewerRepo: InterviewerRepository;
}): {
  fetchInterviewers: _fetchInterviewersUsecase;
} => {
  const { interviewerRepo } = dependencies;

  const fetchInterviewers = buildFetchInterviewers({ interviewerRepo });

  return { fetchInterviewers };
};

export type fetchInterviewersUsecase = _fetchInterviewersUsecase;
